import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

const CurrencyInput = ({
  value,
  onChange,
  currency = 'BRL',
  label = 'Valor',
  size = 'small',
  fullWidth = true,
  required = false,
  error = false,
  helperText = '',
  disabled = false,
  ...props
}) => {
  const getCurrencySymbol = (curr) => {
    switch (curr) {
      case 'USD':
        return '$';
      case 'BRL':
      default:
        return 'R$';
    }
  };

  const formatValue = (val) => {
    const cents = Math.round((val || 0) * 100);
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  const handleKeyDown = (e) => {
    const currentCents = Math.round((value || 0) * 100);

    if (e.key === 'Backspace') {
      e.preventDefault();
      const newCents = Math.floor(currentCents / 10);
      onChange(newCents / 100);
      return;
    }

    if (e.key === 'Delete') {
      e.preventDefault();
      onChange(0);
      return;
    }

    if (/^\d$/.test(e.key)) {
      e.preventDefault();
      const digit = parseInt(e.key, 10);
      const newCents = currentCents * 10 + digit;
      onChange(newCents / 100);
      return;
    }

    const allowedKeys = ['Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      size={size}
      type="text"
      label={label}
      value={formatValue(value)}
      onChange={() => {}}
      onKeyDown={handleKeyDown}
      fullWidth={fullWidth}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{getCurrencySymbol(currency)}</InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default CurrencyInput;
